
define('utilities',[
    "jquery",
    "underscore",
    "logging",
    "storage"
], function ($, _, logging, storage) {
    var _ModuleName = "Utilities";
    var _DeviceScreenWidth = $(window).width();
    var _ScreenMaxWidth = {
        Large: 1300,
        Medium: 1000,
        Small: 768,
        XSmall: 480
    };
    var _DeviceType = {
        get Phone() { return _DeviceScreenWidth < _ScreenMaxWidth.Small; },
        get Tablet() { return _DeviceScreenWidth < _ScreenMaxWidth.Large && !this.Phone; },
        get Desktop() { return !this.Phone && !this.Tablet; }
    };

    var DocumentReady = false;
    var _Intialized = false;
    var _ReadyMonitor = {};
    var _Environments = { 
        Production: "production",
        Development: "development"
    }
    var _CurrentEnvironment = _Environments.Production;
    var _config = {
        storage: {
            tracking: "utils_tracking_"
        }
    }

    function init() {
        if (_Intialized) return;

        // cache a couple dom objects
        $window = $(window);
        
        console.log("Environment: " + _CurrentEnvironment);

        // initialize logging
        var enableLogging = getParameter(document.URL, 'regpath_debug');
        if(enableLogging == "true" || enableLogging == "1") {
            storage.setSessionStorage('regpath-debug', "true");
        } else {
            enableLogging = storage.getSessionStorage('regpath-debug');
        }
        logging.init(enableLogging == "true" || enableLogging == "1" || isDevelopment());
        
        logging.debug("Logging Enabled", _ModuleName);

        /* ============ Handle Mobile Detection ============ */

        logging.debug("Window Width Detected: " + $window.width(), _ModuleName);
        logging.debug(_DeviceType.Desktop ? "This is a desktop device!" : "This is a mobile device!", _ModuleName);

        DocumentReady = false;
        $(function () {
            logging.debug("Document is ready!", _ModuleName);
            DocumentReady = true;
        });

        _Intialized = true;
        logging.debug("Regpath Utilities Initialized", _ModuleName);
    }

    function isDevelopment() {
        return _CurrentEnvironment == _Environments.Development;
    }

    // Get Cookie Data by Name
    function getCookie(sName) {
        sName = sName.toLowerCase();
        var oCrumbles = document.cookie.split(';');
        for (var i = 0; i < oCrumbles.length; i++) {
            var oPair = oCrumbles[i].split('=');
            var sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
            var sValue = oPair.length > 1 ? oPair[1] : '';
            if (sKey == sName)
                return decodeURIComponent(sValue);
        }
        return '';
    }

    // Set cookie name/value
    function setCookie(sName, sValue) {
        setCookie(sName, sValue, 365);
    }

    // Set cookie name/value/expiration (days)
    function setCookie(sName, sValue, expDays) {
        var oDate = new Date();
        oDate.setDate(oDate.getDate() + expDays);
        var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/';
        document.cookie = sCookie;
    }

    // Set cookie name/value/expiration (hours)
    function setCookieByHours(sName, sValue, expHours) {
        var oDate = new Date();
        oDate.setTime(oDate.getTime() + (expHours*60*60*1000));
        var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/';
        document.cookie = sCookie;
    }

    // Get URL Parameter
    function getParameter(url, name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(url);
        var response = results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        return response == null ? "" : response;
    }

    function cleanString(s) {
        s = s.replace(/[\n\r]+/g, '');
        s = s.replace(/\s{2,10}/g, ' ');

        return s;
    }

    function htmlSubstring(s, n) {
        var m, r = /<([^>\s]*)[^>]*>/g,
            stack = [],
            lasti = 0,
            result = '';

        //for each tag, while we don't have enough characters
        while ((m = r.exec(s)) && n) {
            //get the text substring between the last tag and this one making sure not to split in the middle of a word
            var mod = s.substring(lasti, m.index).indexOf(' ', n); n = mod !== -1 ? mod : n;
            var temp = s.substring(lasti, m.index).substr(0, n);
            //append to the result and count the number of characters added
            result += temp;
            n -= temp.length;
            lasti = r.lastIndex;

            if (n) {
                result += m[0];
                if (m[1].indexOf('/') === 0) {
                    //if this is a closing tag, than pop the stack (does not account for bad html)
                    stack.pop();
                } else if (m[1].lastIndexOf('/') !== m[1].length - 1) {
                    //if this is not a self closing tag than push it in the stack
                    stack.push(m[1]);
                }
            }
        }

        //add the remainder of the string, if needed (there are no more tags in here)
        result += s.substr(lasti, n);

        //fix the unclosed tags
        while (stack.length) {
            result += '</' + stack.pop() + '>';
        }

        return result;

    }

    function isAValidEmailAddress(arg) {
        var emailAddress = '';
        if (arg instanceof jQuery)
            emailAddress = arg.val();
        else if (typeof (arg) === 'string' || arg instanceof String)
            emailAddress = arg;
        else if (arg instanceof HTMLInputElement)
            emailAddress = arg.value;
        else
            throw new Error("invalid argument passed to isAValidEmailAddress. expected: (string | jQuery obj | html input), got: " + typeof (arg));

        if (/^\w+([\.\+-]?\w+)*@\w+([\.\+-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
            return true;
        }
        return false;
    }

    function Guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Compare array contents, but order doesn't matter
    function compareArrays(arr1, arr2) {
        // if either array is a falsy value, return
        if (!arr1 || !arr2)
            return false;

        // compare lengths - can save a lot of time 
        if (arr1.length != arr2.length)
            return false;

        for (var i = 0, l = arr1.length; i < l; i++) {
            // Check if we have nested arrays
            if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
                // recurse into the nested arrays
                if (!arr1[i].equals(arr2[i]))
                    return false;
            }
            else if (arr1[i] != arr2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    }

    function setData(elem, name, value)
    {
        // Set Data Value in Memory
        $(elem).data(name, value);
        // Update DOM with Data
        $(elem).attr('data-' + name, value);
    }

    function isArrayInArray(arr, item) {
        for(var i = 0; i < arr.length; i++) {
            if(_.difference(arr[i], item) == 0) return true;
        }
        return false;
    }

    function removeArrayFromArray(arr, item) {
        var newArr = [];
        for(var i = 0; i < arr.length; i++) {
            if(_.difference(arr[i], item) > 0) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    }

    // Get's tracking value with given name
    function getTrackingValue(name) {
        // url overrides stored value
        var urlValue = getParameter(document.URL, name);
        if(urlValue) return urlValue;

        return storage.getSessionStorage(_config.storage.tracking + name);
    }

    // Set's tracking value with given name in session storage
    function setTrackingValue(name, value) {
        storage.setSessionStorage(_config.storage.tracking + name, value);
    }

    function arrayUnique(array) {
        var a = array.concat();
        for(var i=0; i<a.length; ++i) {
            for(var j=i+1; j<a.length; ++j) {
                if(a[i] === a[j])
                    a.splice(j--, 1);
            }
        }
    
        return a;
    }

    // Utility to generate a random alphanumeric string
    function randomString(length, chars) {
        chars = chars || 'abcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for (var i = length; i > 0; --i) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }
        return result;
    }

    function getBrandNameFromDomain() {
        const hostnameParts = window.location.hostname.split('.');
        return hostnameParts.length > 1 ? hostnameParts[1] : ''; // Get the second part as brand name
    }
    
    return {
        init: init,
        getCookie: getCookie,
        setCookie: setCookie,
        setCookieByHours: setCookieByHours,
        getParameter: getParameter,
        cleanString: cleanString,
        htmlSubstring: htmlSubstring,
        isAValidEmailAddress: isAValidEmailAddress,
        IsMobile: (function () { return _DeviceType.Phone || _DeviceType.Tablet; }),
        IsPhone: (function () { return _DeviceType.Phone; }),
        IsTablet: (function () { return _DeviceType.Tablet; }),
        IsDesktop: (function () { return _DeviceType.Desktop; }),
        Guid: Guid,
        compareArrays: compareArrays,
        setData: setData,
        isDevelopment: isDevelopment,
        isArrayInArray: isArrayInArray,
        removeArrayFromArray: removeArrayFromArray,
        getTrackingValue: getTrackingValue,
        setTrackingValue: setTrackingValue,
        arrayUnique: arrayUnique,
        randomString: randomString,
        getBrandNameFromDomain: getBrandNameFromDomain,
    }
});
